import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 10,
	viewBox: "0 0 6 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.361871 2.72363L2.55318 7.1056C2.73747 7.47411 3.26337 7.47408 3.44761 7.10555L5.63826 2.72358C5.80446 2.39113 5.56272 2 5.19104 2H0.809072C0.437367 2 0.19562 2.39118 0.361871 2.72363Z",
		fill: "#525252"
	})
});
export default SvgArrowDown;
